"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = exports.getStringFromObject = exports.formatTimeA11y = exports.formatTime = exports.cloneElement = void 0;
var lang = "en";
try {
    lang = document.documentElement.lang.toLowerCase() === "fr" ? "fr" : "en";
}
catch (e) {
    lang = "en";
}
/*
 * create a new copy of the element using another document
 * NOTE: IE will block appending any element created in a different window context
 *       from the window context that the element is being appended to.
 */
function cloneElement(document, element) {
    var newElement = document.createElement(element.tagName);
    newElement.innerHTML = element.innerHTML;
    return newElement;
}
exports.cloneElement = cloneElement;
// format a number to a more appropriate string
function formatTime(numberOfSeconds) {
    var minutes = String(Math.floor(numberOfSeconds / 60));
    var seconds = String(Math.ceil(numberOfSeconds % 60));
    if (seconds.length <= 1) {
        seconds = "0" + seconds;
    }
    return "".concat(minutes, ":").concat(seconds);
}
exports.formatTime = formatTime;
// format a number to a more appropriate string
function formatTimeA11y(numberOfSeconds) {
    var minutes = Math.floor(numberOfSeconds / 60);
    var seconds = Math.ceil(numberOfSeconds % 60);
    var parts = [];
    if (minutes > 0) {
        parts.push(minutes);
        parts.push(minutes === 1 ? "minute" : "minutes");
    }
    parts.push(seconds);
    if (lang === "fr")
        parts.push(minutes === 1 ? "seconde" : "secondes");
    else
        parts.push(seconds === 1 ? "second" : "seconds");
    return parts.join(" ");
}
exports.formatTimeA11y = formatTimeA11y;
function getStringFromObject(object) {
    var keys = Object.keys(object);
    return keys.reduce(function (string, key, index) {
        var separator = index < keys.length - 1 ? "," : "";
        var value = object[key];
        return string.concat("".concat(key, "=").concat(value).concat(separator));
    }, "");
}
exports.getStringFromObject = getStringFromObject;
function isIE() {
    return !!window.MSInputMethodContext && !!document.documentMode;
}
exports.isIE = isIE;
//# sourceMappingURL=module.js.map